module.exports = __webpack_public_path__ + "img/enTxt3.897286e4.png";